import { NavLink, useParams } from "react-router-dom";

const TabMenu = () => {
  const { id } = useParams(); // Get customer ID from URL

  const tabs = [
    { name: "Details", path: `/companies/${id}/details` },
    { name: "Invoices", path: `/companies/${id}/invoices` },
    { name: "Payments", path: `/companies/${id}/payments` },
    { name: "Documents", path: `/companies/${id}/documents` },
    { name: "Tickets", path: `/companies/${id}/tickets` },
  ];

  return (
    <div className="flex gap-2 overflow-x-auto border-b pb-2">
      {tabs.map((tab) => (
        <NavLink
          key={tab.name}
          to={tab.path}
          className={({ isActive }) =>
            `whitespace-nowrap rounded-t-lg px-4 py-2 text-sm font-medium text-gray-600 hover:text-[#90c740] sm:text-base ${
              isActive ? "border-b-2 border-[#90c740] font-semibold text-[#90c740]" : ""
            }`
          }
        >
          {tab.name}
        </NavLink>
      ))}
    </div>
  );
};

export default TabMenu;
